import ProgressBar from '@luminopia/react-toolbox/lib/progress_bar'
import { Table, TableCell, TableHead, TableRow } from '@luminopia/react-toolbox/lib/table'
import Search from 'core/components/search'
import * as React from 'react'
import { connect, Dispatch } from 'react-redux'
import Card from 'study_reviewer/components/Card'
import { reviewerShowRoute } from 'study_reviewer/routes'
import { getReviewersRequest, historyPushRequest, IState, selectReviewers } from 'study_reviewer/store'
import * as classNames from './PhysiciansListPage.css'

export interface IReviewerRow {
  firstName: string
  lastName: string
  npi: string
  email: string
  isApproved: boolean
  createdTime: string
}

interface IStateProps {
  reviewers: IReviewerRow[]
  isFetching: boolean
}

interface IDispatchProps {
  onMount?: () => void
  onClickReviewer?: (npi: string) => void
}

interface IOwnProps {}

export interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

interface IComponentState {
  filterValue: string
  sortColumn: keyof IReviewerRow
  sortDirection: 'asc' | 'desc'
}

export class ReviewersListPage extends React.Component<IProps, IComponentState> {
  public state: IComponentState = {
    filterValue: '',
    sortColumn: 'createdTime',
    sortDirection: 'desc',
  }

  private handleSort = (column: keyof IReviewerRow) => {
    this.setState((prevState) => ({
      sortColumn: column,
      sortDirection:
        prevState.sortColumn === column
          ? prevState.sortDirection === 'asc'
            ? 'desc'
            : 'asc'
          : 'asc',
    }))
  }

  private renderSortIcon = (column: keyof IReviewerRow) => {
    const { sortColumn, sortDirection } = this.state
    if (column === sortColumn) {
      return (
        <i className={`material-icons ${classNames.sortIcon}`}>
          {sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'}
        </i>
      )
    }
    return null
  }

  public render() {
    if (this.props.isFetching) {
      return <ProgressBar type='circular' mode='indeterminate' multicolor />
    }

    const filteredReviewers = this.props.reviewers.filter((reviewer) => {
      if (!reviewer) return false
      const compareValue = this.state.filterValue.toUpperCase()
      return (
        reviewer.npi.toUpperCase().includes(compareValue) ||
        reviewer.lastName.toUpperCase().includes(compareValue) ||
        reviewer.email.toUpperCase().includes(compareValue)
      )
    })

    const sortedReviewers = filteredReviewers.slice().sort((a, b) => {
      const { sortColumn, sortDirection } = this.state;
      const sortMultiplier = sortDirection === 'asc' ? 1 : -1;

      let aVal = a[sortColumn];
      let bVal = b[sortColumn];

      if (typeof aVal === 'boolean' && typeof bVal === 'boolean') {
        const aNum = aVal ? 1 : 0;
        const bNum = bVal ? 1 : 0;
        return sortMultiplier * (aNum - bNum);
      }

      if (typeof aVal === 'string' && typeof bVal === 'string') {
        return sortMultiplier * aVal.localeCompare(bVal);
      }

      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return sortMultiplier * (aVal - bVal);
      }

      return 0;
    });

    return (
      <div>
        <Card>
          <Search
            value={this.state.filterValue}
            label='Search by NPI, Last Name or Email'
            onChange={this.handleChangeFilterValue}
            onClickClear={() => this.handleChangeFilterValue('')}
          />
          <Table selectable={false}>
            <TableHead>
              <TableCell
                className={classNames.sortableColumn}
                onClick={() => this.handleSort('npi')}
              >
                NPI {this.renderSortIcon('npi')}
              </TableCell>
              <TableCell
                className={classNames.sortableColumn}
                onClick={() => this.handleSort('firstName')}
              >
                First Name {this.renderSortIcon('firstName')}
              </TableCell>
              <TableCell
                className={classNames.sortableColumn}
                onClick={() => this.handleSort('lastName')}
              >
                Last Name {this.renderSortIcon('lastName')}
              </TableCell>
              <TableCell
                className={classNames.sortableColumn}
                onClick={() => this.handleSort('email')}
              >
                Email {this.renderSortIcon('email')}
              </TableCell>
              <TableCell
                className={classNames.sortableColumn}
                onClick={() => this.handleSort('isApproved')}
              >
                Is Approved {this.renderSortIcon('isApproved')}
              </TableCell>
            </TableHead>
            {sortedReviewers.map((reviewer) => {
              const { onClickReviewer } = this.props
              const onClick = () => onClickReviewer && onClickReviewer(reviewer.npi)
              return (
                <TableRow
                  key={reviewer.npi}
                  className={reviewer.isApproved ? null : classNames.isNotActive}
                >
                  <TableCell className={classNames.cell} onClick={onClick}>
                    {reviewer.npi}
                  </TableCell>
                  <TableCell className={classNames.cell} onClick={onClick}>
                    {reviewer.firstName}
                  </TableCell>
                  <TableCell className={classNames.cell} onClick={onClick}>
                    {reviewer.lastName}
                  </TableCell>
                  <TableCell className={classNames.cell} onClick={onClick}>
                    {reviewer.email}
                  </TableCell>
                  <TableCell className={classNames.cell} onClick={onClick}>
                    {reviewer.isApproved ? 'yes' : 'no'}
                  </TableCell>
                </TableRow>
              )
            })}
          </Table>
        </Card>
      </div>
    )
  }

  public componentDidMount() {
    if (this.props.onMount) this.props.onMount()
  }

  private handleChangeFilterValue = (value: string) => {
    this.setState({ filterValue: value })
  }
}

const mapStateToProps = (state: IState): IStateProps => {
  return {
    reviewers: selectReviewers(state),
    isFetching: state.reviewers.isFetching,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<void>) => ({
  onMount: () => dispatch(getReviewersRequest()),
  onClickReviewer: (npi: string) =>
    dispatch(historyPushRequest(reviewerShowRoute(npi))),
})

export default connect<IStateProps, IDispatchProps, IOwnProps, IState>(
  mapStateToProps,
  mapDispatchToProps
)(ReviewersListPage)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/pages/PhysiciansListPage.tsx